<template>
  <a>
    <span class="modal-body-text"
      >You are about to delete this File Source.</span
    ><br /><br />
    <span class="modal-body-text">Are you sure you want to continue?</span>
    <br />
  </a>
</template>

<script>
export default {
  name: "delete-file-source-modal"
};
</script>



// WEBPACK FOOTER //
// src/components/modal/DeleteFileSource.vue